export const giftsDictionary = {
  giftBag: { id: "16070" },
  giftBox: { id: "14283" },
  giftCard: { id: "3654" },
};
